import { NotificationBase } from '../interfaces/notification-base.interface';
import { AlertComponent as AlertNotification } from './alert/alert.component';

import { MessageComponent as MessageNotification } from './message/message.component';
import { DocumentRequestNotificationsComponent as DocumentRequestNotification } from './document-request/document-request.component';
import {WorkflowComponent as WorkflowNotification} from './workflow/workflow.component'

export const TYPES_COMPONENTS = [AlertNotification, MessageNotification,WorkflowNotification];
export type NotificationType =
  | NotificationBase
  | AlertNotification
  | MessageNotification
  | DocumentRequestNotification
  | WorkflowNotification


export const NotificationTypes = {
  alert: AlertNotification,
  message: MessageNotification,
  documentRequest: DocumentRequestNotification,
  workflow:WorkflowNotification
};
